import { useQuery } from '@tanstack/react-query';
import axiosInstance, { getAPIURL } from '../axiosInstance';
import { Users } from '../../types/Types';

interface UseGetUserProps {
  id: string;
  enabled?: boolean;
  refetchOnMount?: boolean;
}

export function useGetUser({ id, enabled = true, refetchOnMount = false }: UseGetUserProps) {
  return useQuery({
    enabled,
    queryKey: ['user', id],
    refetchOnMount,
    queryFn: async () => {
      return axiosInstance<Users>(getAPIURL(`/User/ByObjectId/${id}?id=${id}`)).then(
        (response) => response.data,
      );
    },
    retry: (failureCount, error: any) => {
      const status = error?.response?.status;
      // Do not retry for client errors
      return status !== 400 && failureCount < 3;
    },
  });
}